import script from "./PopupMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupMenu.vue?vue&type=script&setup=true&lang=js"

import "./PopupMenu.vue?vue&type=style&index=0&id=9380f456&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9380f456"]])

export default __exports__